var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBenefitNotification = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1C9CFF",
  d: "M18.588 13.954v-5.72h-3.45a3.45 3.45 0 0 1-3.451-3.45V1.331H4.785q-3.45 0-3.451 3.451v13.804q0 3.45 3.45 3.45h13.805v-8.083Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#90D5FF",
  d: "M15.137 8.234h3.45l-6.901-6.901v3.45q0 3.451 3.45 3.451Zm-1.149 4.314H5.936a.863.863 0 0 1 0-1.725h8.052a.863.863 0 0 1 0 1.725M11.4 16.287a.863.863 0 0 0-.863-.863h-4.6a.863.863 0 0 0 0 1.725h4.6a.863.863 0 0 0 .863-.862"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF6562",
  d: "M22.587 18.756c-.552 2.68-4.156 4.224-4.156 4.224s-3.603-1.543-4.155-4.224c-.339-1.644.402-3.298 2.283-3.306 1.402-.007 1.872 1.324 1.872 1.324s.471-1.33 1.873-1.324c1.886.008 2.622 1.662 2.283 3.306"
})));
export default SvgBenefitNotification;